/* eslint-disable @typescript-eslint/no-empty-function */
import { FC } from 'react';
import { useSTKContext } from '@/context/context';
import { usePriceDeviations } from '@/services/menu/menus.service';
import { PriceDeviationsDrawerShared } from '@/pages/Franchisee/SharedComponents/PriceDeviations/PriceDeviationsDrawerShared';
import { ProductPriceDeviationsDrawerProps } from './ProductPriceDeviationsDrawerProps.types';

export const ProductPriceDeviationsDrawer: FC<ProductPriceDeviationsDrawerProps> = ({
  isOpen,
  onClose,
  variantIds,
  selectedGroupName,
  cameFromEditDrawer,
}) => {
  const { storesAndGroups } = useSTKContext();
  const selectedStores =
    storesAndGroups?.origin === 'tab-stores-groups'
      ? storesAndGroups.storeGroups?.find((item) => item.storeGroup === selectedGroupName)?.stores || []
      : storesAndGroups?.stores?.filter((item) => item.storeGroup === selectedGroupName).map((item) => item.storeNo) ||
        [];

  const { data: priceDeviations = [], isLoading } = usePriceDeviations(true, selectedStores, variantIds);

  return (
    <PriceDeviationsDrawerShared
      isOpen={isOpen}
      onClose={onClose}
      selectedGroupName={selectedGroupName}
      data={priceDeviations}
      isLoading={isLoading}
      cameFromEditDrawer={cameFromEditDrawer}
    />
  );
};
